import React from 'react';

/*
 * PaperClip
 * An original SVG paperclip used to pin paper elements. Decorative
 * (aria-hidden). Reusable — size and placement come from the parent via
 * `className` / `width`.
 */
function PaperClip({ className = '', width = 34, stroke = '#b9863c', highlight = '#e0c98f' }) {
  return (
    <svg
      className={className}
      width={width}
      height={width * 2.4}
      viewBox="0 0 34 82"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M24.5 20v40a8.5 8.5 0 0 1-17 0V16a5.5 5.5 0 0 1 11 0v42a2.5 2.5 0 0 1-5 0V22"
        stroke={stroke}
        strokeWidth="3.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* soft steel highlight */}
      <path
        d="M24.5 20v40a8.5 8.5 0 0 1-17 0V16a5.5 5.5 0 0 1 11 0v42a2.5 2.5 0 0 1-5 0V22"
        stroke={highlight}
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PaperClip;
